import { Divider, Group, Stack } from '@mantine/core';
import Text from '@ui/components/Text/Text';
import Icon from '@ui/components/Icon/Icon';
import { truncateMiddle } from 'src/lib/stringUtils';
import type { BackgroundTaskError } from '../../../models/BackgroundTask';

type BackgroundTaskErrorDescriptionProps = {
	error: BackgroundTaskError;
	showBorderBottom?: boolean;
};

const BackgroundTaskErrorDescription = ( { error, showBorderBottom = false }: BackgroundTaskErrorDescriptionProps ) => (
	<Stack spacing={0} p="0 8px">
		<Group key={error.identifier} spacing="12px" noWrap align="flex-start" p="10px 0">
			<Stack spacing="4px" style={{ flexGrow: 1 }} align="flex-start">
				<Text variant="caption-regular" color="black" aria-label={error.identifier}>
					{truncateMiddle( error.identifier, 42 )}
				</Text>
				<Text variant="footnote" color="dark.3" align="right">{error.message}</Text>
			</Stack>
			<Icon icon="error" size={16} color="red.3" />
		</Group>
		{showBorderBottom && <Divider h="1px" color="gray.1" />}
	</Stack>
);

export default BackgroundTaskErrorDescription;
